module.exports = __webpack_public_path__ + "img/5.cde08d7f.png";